import { useQuery } from '@tanstack/react-query';
import type { MapaMensal } from '@/types';
import * as api from './api';

export function useMapaMensal(mes: string, userId?: string, obraId?: string) {
  return useQuery<MapaMensal>({
    queryKey: ['mapas', 'mensal', mes, userId ?? 'todos', obraId ?? 'todas'],
    queryFn: () => api.fetchMapaMensal(mes, userId, obraId),
  });
}

/** Streams a generated file to the device — the only way out of a phone browser. */
async function saveBlob(blob: Blob, fileName: string): Promise<void> {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export async function downloadMapaMensal(mes: string, userId?: string): Promise<void> {
  const { blob, fileName } = await api.exportMapaMensal(mes, userId);
  await saveBlob(blob, fileName);
}

/** The printable monthly report — includes every observação, unlike the CSV. */
export async function downloadMapaMensalPdf(mes: string, userId?: string): Promise<void> {
  const { blob, fileName } = await api.exportMapaMensalPdf(mes, userId);
  await saveBlob(blob, fileName);
}
